<div class="modal-header">
  <h4
    class="modal-title">{{ [companies.Seca, companies.SeaIm].includes(company) && !hqSelected ? 'Store' : 'Dealer' }}</h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<form (keydown.enter)="$event.preventDefault()" (submit)="submitForm($event)" [formGroup]="detailForm">
  <div class="modal-body">
    <div class="card-body">
      <div *ngIf="showOnboarding" class="row">
        <div class="col-md-6 d-flex"></div>
        <div class="col-md-6 d-flex gap-4 justify-content-end">
          <button (click)="openAddUserModal()"
                  class="btn btn-dark"
                  type="button">Add User
          </button>
          <button (click)="openAddStoreModal()"
                  class="btn btn-dark"
                  type="button">Add Store
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label
              for="name-input">{{ [companies.Seca, companies.SeaIm].includes(company) && !hqSelected ? 'Store' : 'Dealer' }}
              Name</label><span class="required">*</span>
            <input class="form-control" formControlName="name" id="name-input" placeholder="Name"
                   type="text">
            <dp-field-error [formField]="form['name']"></dp-field-error>
          </div>
        </div>
        <div *ngIf="isAdmin && bpNo" class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="name-input">BP #</label>
            <input (blur)="checkBpNo($event)"
                   class="form-control"
                   formControlName="bpNo"
                   id="bpNo-input"
                   placeholder="BP #"
                   type="text">
            <dp-field-error [formField]="form['bpNo']"></dp-field-error>
          </div>
        </div>
      </div>
      <div *ngIf="isAdmin && [companies.Sea, companies.Seca].includes(company)" class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label class="detail-item-label" for="hq-input">HQ</label>
            <div class="checkbox-container">
              <input (change)="setHqOptions($event)" formControlName="hq" id="hq-input" type="checkbox">
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label class="detail-item-label" for="hqBpNo-input">{{ labelHq }}</label><span
            class="required">*</span>
            <div>
              <ng-select [items]="hqOptions"
                         [multiple]="false"
                         bindLabel="name"
                         bindValue="code"
                         class="form-control"
                         formControlName="hqBpNo"
                         id="hqBpNo-input"
                         placeholder="{{placeHolderHq}}">
              </ng-select>
              <dp-field-error [formField]="form['hqBpNo']"></dp-field-error>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isAdmin" class="row">
        <div
          *ngIf="[companies.Sea].includes(company) || ([companies.Seca, companies.SeaIm].includes(company) && dealerInfo) "
          class="col-md-6">
          <div class="mb-3 position-relative">
            <label class="detail-item-label" for="hq-input">Status</label>
            <div>
              <ng-select [items]="statuses"
                         [multiple]="false"
                         bindLabel="name"
                         bindValue="code"
                         class="form-control"
                         formControlName="status"
                         id="status-input"
                         placeholder="Status">
              </ng-select>
            </div>
          </div>
        </div>
        <div *ngIf="[companies.Sea].includes(company)" class="col-md-6">
          <div class="mb-3 position-relative">
            <label class="detail-item-label" for="hq-input">RA Request</label>
            <div>
              <ng-select [items]="concealedDamageTypes"
                         [multiple]="false"
                         bindLabel="name"
                         bindValue="code"
                         class="form-control"
                         formControlName="concealedDamageType"
                         id="concealedDamage-input"
                         placeholder="RA Request Type">
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-16px"></div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label
              for="contact-input">{{ ([companies.Seca].includes(company) && isDealer) || [companies.SeaIm].includes(company) ? 'Store ' : '' }}
              Phone #</label><span
            class="required">*</span>
            <input class="form-control" formControlName="mainContact"
                   id="contact-input"
                   placeholder="Only 10 digit numbers allowed"
                   maxlength="10"
                   minlength="10"
                   type="text">
            <dp-field-error [formField]="form['mainContact']"></dp-field-error>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label
              for="email-input">{{ ([companies.Seca].includes(company) && isDealer) || [companies.SeaIm].includes(company) ? 'Store ' : '' }}
              Email</label><span
            class="required">*</span>
            <input (blur)="checkEmail('mainEmail', $event)" class="form-control"
                   formControlName="mainEmail"
                   id="email-input"
                   placeholder="{{company === companies.Seca && isDealer ? 'Store ' : ''}}Email"
                   type="email">
            <dp-field-error [formField]="form['mainEmail']"></dp-field-error>
          </div>
        </div>
      </div>
      <div>
        <label>{{ ([companies.Seca].includes(company) && isDealer) || [companies.SeaIm].includes(company) ? 'Store ' : '' }}
          Address</label><span class="required">*</span>
      </div>
      <app-google-places-autocomplete [country]="country" [data]="addressData" [disabled]="noReset"
                                      [noDirect]="dealerInfo?.noDirect"></app-google-places-autocomplete>

      <div *ngIf="!bpNo" class="card-body">
        <div class="modal-sub-header">
          <h4 class="modal-title onboarding-title">Contact Person</h4>
        </div>
        <div class="mb-16px"></div>
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3 position-relative">
              <label for="contact-input">First Name</label><span class="required">*</span>
              <input class="form-control" formControlName="firstName"
                     id="firstName-input"
                     placeholder="First Name"
                     type="text">
              <dp-field-error [formField]="form['firstName']"></dp-field-error>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3 position-relative">
              <label for="email-input">Last Name</label><span class="required">*</span>
              <input class="form-control"
                     formControlName="lastName"
                     id="lastName-input"
                     placeholder="Last Name"
                     type="email">
              <dp-field-error [formField]="form['lastName']"></dp-field-error>
            </div>
          </div>
        </div>
        <div class="mb-16px"></div>
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3 position-relative">
              <label for="contact-input">Phone #</label><span *ngIf="[companies.SeaIm].includes(company)"
                                                              class="required">*</span>
              <div class="d-flex">
                <input class="form-control phone-number" formControlName="contactTel"
                       id="contactTel-input"
                       placeholder="Only 10 digit numbers allowed"
                       minlength="10"
                       maxlength="10"
                       type="text">
                <input class="form-control phone-number-ext ml-8px" formControlName="contactExt"
                       id="contactExt-input"
                       placeholder="Ext."
                       type="text">
              </div>
              <dp-field-error [formField]="form['contactTel']"></dp-field-error>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3 position-relative">
              <label for="email-input">Email</label><span class="required">*</span>
              <input (blur)="checkEmail('contactEmail', $event)" class="form-control"
                     formControlName="contactEmail"
                     id="contactEmail-input"
                     placeholder="Contact Email"
                     type="email">
              <dp-field-error [formField]="form['contactEmail']"></dp-field-error>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isAdmin && [companies.Sea].includes(company)" class="col-md-6">
        <div class="mb-3 position-relative">
          <label for="email-input">Escalation Email</label>
          <input class="form-control" formControlName="escalationEmail"
                 id="escalationEmail-input"
                 placeholder="Escalation Email"
                 type="email">
          <dp-field-error [formField]="form['escalationEmail']"></dp-field-error>
        </div>
      </div>
    </div>
    <div *ngIf="showOnboarding" class="card-body">
      <div class="modal-sub-header">
        <h4 class="modal-title onboarding-title">Onboarding</h4>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3 position-relative flex-row">
            <label for="distributorName">Do you purchase your Samsung products from a distributor? If so, please provide
              name of distributor.</label>
            <div class="d-flex">
              <input class="form-control" formControlName="distributorName"
                     id="distributorName"
                     placeholder="Distributor Name"
                     type="text">
            </div>
            <dp-field-error [formField]="form['distributorName']"></dp-field-error>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label for="name-input">Request Date</label>
            <input class="form-control" formControlName="requestDate" id="requestDate-input" placeholder="Request Date"
                   type="text">
            <dp-field-error [formField]="form['requestDate']"></dp-field-error>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3 position-relative">
            <label class="detail-item-label" for="hqBpNo-input">Request Status</label>
            <div>
              <ng-select [items]="requestStatus"
                         [multiple]="false"
                         bindLabel="name"
                         bindValue="code"
                         class="form-control"
                         formControlName="requestStatus"
                         id="requestStatus-input"
                         placeholder="Select Status">
              </ng-select>
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="row">-->
      <!--        <div class="col-md-6">-->
      <!--          <div class="mb-3 position-relative">-->
      <!--            <label class="detail-item-label" for="hq-input">Reviewed Date</label>-->
      <!--            <div class="checkbox-container">-->
      <!--              <input class="form-control" formControlName="reviewedDate" id="approvalDate-input"-->
      <!--                     placeholder="Reviewed Date"-->
      <!--                     type="text">-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="col-md-6">-->
      <!--          <div class="mb-3 position-relative">-->
      <!--            <label class="detail-item-label" for="hq-input">Reviewed By</label>-->
      <!--            <div class="checkbox-container">-->
      <!--              <input class="form-control" formControlName="reviewedBy" id="approvedBy-input" placeholder="Reviewed By"-->
      <!--                     type="text">-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3 position-relative">
            <label class="detail-item-label" for="hq-input">Reasons</label>
            <div>
              <input class="form-control" formControlName="rejectReason" id="reason-input" placeholder="Reason"
                     type="text">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
<div *ngIf="!showOnboarding" class="modal-footer">
  <button (click)="submitForm($event)" class="btn btn-dark button-large" type="submit">{{ buttonLabel }}</button>
</div>
<div *ngIf="showOnboarding" class="modal-footer">
  <button (click)="deleteRequestedDealer()" class="btn btn-outline-dark button-large" type="submit">Delete</button>
  &nbsp;&nbsp;&nbsp;
  <button (click)="updateRequestStatus($event, 'REJECTED')" class="btn btn-outline-dark button-large" type="submit">
    Reject
  </button>
  &nbsp;&nbsp;&nbsp;
  <button (click)="updateRequestStatus($event, 'ACCEPTED')" class="btn btn-dark button-large" type="submit">Accept
  </button>
</div>
